import { Box } from "@mui/material";

export const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        font: "normal normal normal 12px/38px Calibri",
        color: "#999999",
        textAlign: "center",
      }}
    >
      © {new Date().getFullYear()} TXOne Networks. All rights reserved.
    </Box>
  );
};
